<ol kb-section>
  <li>
    <a
      kb-link
      [kbRouterOrExternalLink]="homeLink.href"
      [attr.target]="homeLink.target"
    >
      {{ intl.breadcrumbHomeLabel }}
    </a>
    <kb-icon [icon]="iconSeparator" icon-uppercase icon-center />
  </li>
  @for (navigationItem of activeNavigation; track navigationItem.href) {
    <li>
      @if (navigationItem.href && navigationItem.href !== currentUrl()) {
        <a
          kb-link
          [kbRouterOrExternalLink]="navigationItem.href"
          [attr.target]="navigationItem.target"
        >
          {{ navigationItem.label }}
        </a>
      } @else {
        <span [attr.aria-current]="navigationItem.href === currentUrl() ? 'page' : null">{{ navigationItem.label }}</span>
      }
      @if (!$last) {
        <kb-icon [icon]="iconSeparator" icon-uppercase icon-center />
      }
    </li>
  }
</ol>
